interface TransformAceleraProps {
  onOpenModal: () => void;
}

export default function TransformAcelera({ onOpenModal }: TransformAceleraProps) {
  return (
    <section className="py-24 lg:py-32 bg-gray-50">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-20">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-semibold text-slate-900 leading-tight">
              Existe uma diferença brutal entre:
            </h2>
          </div>
          
          {/* Comparison */}
          <div className="grid lg:grid-cols-2 gap-8 mb-16">
            {/* Left - Empresas que fazem marketing */}
            <div className="bg-white rounded-2xl p-10 border border-gray-200 shadow-sm">
              <div className="mb-8">
                <h3 className="text-2xl font-semibold text-gray-500 leading-tight">
                  Empresas que<br />"fazem marketing"
                </h3>
              </div>
              <div className="space-y-4 text-gray-600">
                <p className="flex items-start gap-3 pb-4 border-b border-gray-100">
                  <span className="text-base leading-relaxed">Dependem de sorte</span>
                </p>
                <p className="flex items-start gap-3 pb-4 border-b border-gray-100">
                  <span className="text-base leading-relaxed">Sem previsibilidade</span>
                </p>
                <p className="flex items-start gap-3 pb-4 border-b border-gray-100">
                  <span className="text-base leading-relaxed">Leads se perdem</span>
                </p>
                <p className="flex items-start gap-3">
                  <span className="text-base leading-relaxed">Resultados instáveis</span>
                </p>
              </div>
            </div>
            
            {/* Right - Empresas que constroem sistema */}
            <div className="bg-slate-900 rounded-2xl p-10 border-l-4 border-orange-600 shadow-xl">
              <div className="mb-8">
                <h3 className="text-2xl font-semibold text-white leading-tight">
                  Empresas que<br />constroem um sistema de vendas
                </h3>
              </div>
              <div className="space-y-4 text-gray-300">
                <p className="flex items-start gap-3 pb-4 border-b border-white/10">
                  <span className="w-1 h-6 bg-orange-600 rounded-full flex-shrink-0"></span>
                  <span className="text-base leading-relaxed font-medium">Tráfego com estratégia</span>
                </p>
                <p className="flex items-start gap-3 pb-4 border-b border-white/10">
                  <span className="w-1 h-6 bg-orange-600 rounded-full flex-shrink-0"></span>
                  <span className="text-base leading-relaxed font-medium">CRM estruturado</span>
                </p>
                <p className="flex items-start gap-3 pb-4 border-b border-white/10">
                  <span className="w-1 h-6 bg-orange-600 rounded-full flex-shrink-0"></span>
                  <span className="text-base leading-relaxed font-medium">Follow-up automatizado</span>
                </p>
                <p className="flex items-start gap-3 pb-4 border-b border-white/10">
                  <span className="w-1 h-6 bg-orange-600 rounded-full flex-shrink-0"></span>
                  <span className="text-base leading-relaxed font-medium">Recuperação da base</span>
                </p>
                <p className="flex items-start gap-3">
                  <span className="w-1 h-6 bg-orange-600 rounded-full flex-shrink-0"></span>
                  <span className="text-base leading-relaxed font-medium">Indicadores claros</span>
                </p>
              </div>
            </div>
          </div>
          
          {/* Closing Statement */}
          <div className="text-center space-y-10">
            <div className="bg-white rounded-2xl p-12 lg:p-16 border border-gray-200 shadow-sm">
              <p className="text-2xl lg:text-3xl font-semibold text-slate-900 mb-4">
                Você deixa de torcer.
              </p>
              <p className="text-2xl lg:text-3xl font-semibold text-orange-600">
                E passa a controlar.
              </p>
            </div>
            
            <button 
              onClick={onOpenModal}
              className="bg-green-600 hover:bg-green-700 text-white px-12 py-4 rounded-lg font-bold text-base transition-all duration-300 cursor-pointer"
            >
              <i className="ri-calendar-line mr-2"></i>
              AGENDAR REUNIÃO
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
